export default {
    baseUrl: {
        dev: '/questionnaire/api',
        pro: '/questionnaire/api'
    }
};
